<template>
  <div
      ref="vuetextareatag"
      class="vue-text-area-tag"
  >
    <div
        class="wrapper"
        v-bind:class="{active:active}"
    >
      <div
          class="text-area-content"
          v-bind:class="{active:active}"
          v-if="!active"
          v-html="renderValue"
      >
      </div>
    </div>
    <textarea
        v-model.lazy.trim="displayValue"
        v-bind:rows="rows"
        v-bind:cols="cols"
        @focusin="isActive"
        @focusout="isInActive"
        v-bind:class="{active:active}"
        v-bind:maxlength="maxlength"
    >
    </textarea>
  </div>
</template>

<script>

import defaultTags from '@/febos/global/billing/settings/PreDefinedTagsTemplates';

export default {
  name: 'BFormTextareaTags',
  props: {
    tags: {
      type: Array,
      default: defaultTags
    },
    value: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    cols: {
      type: Number,
      default: 30
    },
    rows: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      active: false,
      mirrorContainer: null
    };
  },
  computed: {
    displayValue: {
      get() {
        return this.value;
      },
      set(modifiedValue) {
        this.$emit('input', modifiedValue);
      }
    },
    renderValue() {
      let current = this.value;
      if (!current) {
        return this.value;
      }
      this.tags.forEach((tag) => {
        if (tag.label) {
          const st = `<span class="tag" title="${tag.label}" v-tooltip="'${tag.label}'">${tag.example}</span>`;
          current = this.replaceAll(current, tag.value, st);
        } else {
          const st = `<span class="tag">${tag}</span>`;
          current = this.replaceAll(current, tag, st);
        }
      });
      return current;
    }
  },
  methods: {
    isInActive() {
      this.active = false;
    },
    isActive() {
      this.active = true;
    },
    escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    replaceAll(str, term, replacement) {
      return str.replace(new RegExp(this.escapeRegExp(term), 'g'), replacement);
    }
  }
};
</script>;

<style>
.vue-text-area-tag {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.vue-text-area-tag .wrapper {
  position: absolute !important;
  top: 0 !important;
  right: -99px !important;
  bottom: 0 !important;
  left: 0 !important;
  padding-right: 99px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.vue-text-area-tag .wrapper .text-area-content {
  width: auto !important;
  height: auto !important;
  border-color: transparent !important;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  overflow: hidden !important;
  background: none transparent !important;
  padding: 20px;
  color: inherit;
}

.vue-text-area-tag .wrapper .text-area-content span {
  background-color: var(--gray) !important;
  font-weight: bold;
  border-radius: 5px;
  margin: 2px;
  padding: 3px;
}

.vue-text-area-tag textarea {
  display: block !important;
  position: relative !important;
  margin: 0;
  border-radius: 0;
  font: inherit;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  width: 100%;
  padding: 20px;
  border: 1px solid #adb5bd;
  color: transparent;
  background: none transparent !important;
}

.vue-text-area-tag textarea.active {
  color: inherit;
}

.vue-text-area-tag .wrapper .text-area-content.active {
  display: none;
}
</style>;
